import { supabase } from '../lib/supabase';
import { StudentEnrollment } from '../types/models';

export const getEnrollmentsForStudent = async (studentId: string): Promise<StudentEnrollment[]> => {
  const { data, error } = await supabase
    .from('student_enrollments')
    .select('*')
    .eq('student_id', studentId)
    .order('competition_year', { ascending: false });
  if (error) throw new Error(error.message);
  return data || [];
};

export const getEnrollmentsForYear = async (year: number): Promise<StudentEnrollment[]> => {
  const { data, error } = await supabase
    .from('student_enrollments')
    .select('*')
    .eq('competition_year', year);
  if (error) throw new Error(error.message);
  return data || [];
};

export const updateEnrollment = async (
  enrollmentId: string,
  patch: Partial<Pick<StudentEnrollment, 'department_id' | 'house_id' | 'active'>>
): Promise<StudentEnrollment> => {
  const { data, error } = await supabase
    .from('student_enrollments')
    .update(patch)
    .eq('enrollment_id', enrollmentId)
    .select()
    .single();
  if (error) throw new Error(error.message);
  return data;
};

export const snapshotEnrollmentsForYear = async (year: number): Promise<number> => {
  const { data, error } = await supabase.rpc('snapshot_enrollments_for_year', {
    target_year: year,
  });
  if (error) throw new Error(error.message);
  return (data as number) ?? 0;
};
